import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/Pageheader";
import Footer from "../Components/Footer";
import Sidebar from "../Components/Sidebar";
import { orderreview } from "../Constant/Index";

function Review() {
  return (
    <>
      <Header />
      <PageHeader pagename="write a review" />
      {/* Write a Review Section  */}
      <section className="profile-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <Sidebar />
            </div>

            <div className="col-md-9">
              <div className="my-info-dv">
                <div className="row">
                  <div className="col-md-6">
                    <div className="my-info-head">
                      <h3 className="primary-color">Write A Review</h3>
                      <span className="primary-color font-weight-semibold">
                        Date : 25 Nov 2024
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="edit-profile-dv">
                      <button className="btn-all" style={{ width: "32%" }}>
                        save
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="info-border"></div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                      
                        <div className="name-info edit-input-info">
                          <h5 className="primary-color">Your Name</h5>
                          <input type="text" placeholder="Enetr Name"/>
                        </div>
                        <div className="name-info edit-input-info">
                          <h5 className="primary-color">Review</h5>
                          <textarea
                            class="form-control"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            placeholder="Enter Review"
                          ></textarea>
                        </div>
                        <div className="submit-btn">
                          <button className="btn-all" style={{ width: "25%" }}>
                            Submit
                          </button>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="order-id">
                          <h3 className="primary-color">
                            Order Id, #000654321
                          </h3>
                          <div className="order-id-img">
                            <img src={orderreview} />
                            <p>Magnesium Bath Salt</p>
                            <p>$ 49.00</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======================= */}

      <Footer />
    </>
  );
}

export default Review;
